import moment from "moment";
import General from "@ecoenghk/general";
import { deviceInfoOfObj } from "actions/generalActions";
import eventEmitter from 'utils/eventEmitter';
const gs = new General();

export const smReducer = (state, action) => {
  // console.log("Finished dispatched", action);
  switch (action.type) {
    case "FETCHED_SERVER_OPERATION_INFO": {
      const { socketGateway, socketWebUser } = action.payload;
      return { ...state, serverSocketGateway: socketGateway, serverSocketWebUser: socketWebUser };
    }
    case "FETCHED_USER": {
      const userObj = action.payload;
      let newState = {
        ...state,
        userObj,
        storedEmail: userObj.email,
      };
      if (userObj.enableFS) {
        newState = { ...newState, enableFS: userObj.enableFS, fs: userObj.fs };
      }
      return newState;
    }
    case "LOGIN_APPROVED": {
      return { ...state, userObj: action.payload };
    }
    case "SET_SOCKET": {
      return { ...state, socket: action.payload };
    }
    case "SHOW_BIG_PROGRESS": {
      return { ...state, showBigProgress: true };
    }
    case "HIDE_BIG_PROGRESS": {
      return { ...state, showBigProgress: false };
    }
    case "OPENED_SNACKBAR": {
      const { title, severity, time } = action.payload;
      return { ...state, snackbarMsg: { title, severity, time, status: true } };
    }
    case "CLOSED_SNACKBAR": {
      return {
        ...state,
        snackbarMsg: { title: "", severity: "", status: false },
      };
    }
    case "WINDOW_CONFIRM": {
      const { status, title, onConfirm, onCancel, callback, showWindowConfirmAlertSign } = action.payload;
      return {
        ...state,
        windowConfirm: status,
        windowConfirmTitle: title,
        onConfirm,
        onCancel,
        callback,
        showWindowConfirmAlertSign,
      };
    }
    case "WINDOW_ALERT": {
      const { status, windowAlertTitle, windowAlertOnClose } = action.payload;
      return { ...state, windowAlert: status, windowAlertTitle, windowAlertOnClose };
    }
    case "WINDOW_PROMPT": {
      const { status, title, onConfirm, defaultValue } = action.payload;
      return {
        ...state,
        windowPrompt: status,
        windowPromptTitle: title,
        onConfirm,
        windowPromptDefaultValue: defaultValue,
      };
    }
    case "WINDOW_BUTTONS": {
      const { status, title, windowButtonsOnChoose, windowButtonsOnCancel, windowBtnContentArray } = action.payload;
      return {
        ...state,
        windowButtons: status,
        windowButtonsTitle: title,
        windowButtonsOnChoose,
        windowButtonsOnCancel,
        windowBtnContentArray,
      };
    }
    case "ADD_MAP_DEVICE_MESSAGE": {
      const { deviceIDArr, messageArr } = action.payload;
      return addMapDeviceMessage(state, deviceIDArr, messageArr);
    }
    case "CLEAR_MAP_DEVICE_MESSAGE": {
      const { deviceID } = action.payload;
      if (deviceID) delete state.mapDeviceMessage[deviceID];
      return { ...state };
    }
    case "ADD_MULTI_SNACKBAR_MSG": {
      const { title, status } = action.payload;
      let newMultiSnackbarMsg = [...(state.multiSnackbarMsg || [])];
      let multiSnackbarMsgBackup = [...(state.multiSnackbarMsgBackup || [])];
      const msgObj = { title: title, show: true, animationKey: gs.getRandomHexID(8), status: status, timeStamp: moment().valueOf() };
      newMultiSnackbarMsg.push(msgObj);
      multiSnackbarMsgBackup.push(msgObj);
      if (newMultiSnackbarMsg.length > 6) {
        newMultiSnackbarMsg.shift();
      }
      if (multiSnackbarMsgBackup.length > 100) {
        multiSnackbarMsgBackup.shift();
      }
      return { ...state, multiSnackbarMsg: newMultiSnackbarMsg, multiSnackbarMsgBackup };
    }
    case "FETCHED_SERVER_OBJ": {
      const serverObj = action.payload;
      // console.log("FETCHED_SERVER_OBJ", serverObj)
      return { ...state, serverObj, serverID: serverObj?.serverID };
    }
    case "FETCHED_MAP_OBJ_ALL": {
      return { ...state, mapObjAll: action.payload };
    }
    case "FETCHED_DEVICES_OBJ_ALL": {
      const { gatewayObjAll, lightObjAll, sensorObjAll, daliCtlObjAll, zoneControlObjAll, modbusSlaveObjAll, adfDeviceObjAll, markObjAll, lmcObjAll, deviceStatus } = action.payload;
      const gatewayQty = Object.keys(gatewayObjAll || {}).length;
      const lightQty = Object.keys(lightObjAll || {}).length;
      const sensorQty = Object.keys(sensorObjAll || {}).length;
      const daliCtlQty = Object.keys(daliCtlObjAll || {}).length;
      const zoneControlQty = Object.keys(zoneControlObjAll || {}).length;
      const modbusSlaveQty = Object.keys(modbusSlaveObjAll || {}).length;
      const adfDeviceQty = Object.keys(adfDeviceObjAll || {}).length;
      const markQty = Object.keys(markObjAll || {}).length;
      const lmcQty = Object.keys(lmcObjAll || {}).length;
      return { ...state, gatewayObjAll, lightObjAll, sensorObjAll, daliCtlObjAll, zoneControlObjAll, modbusSlaveObjAll, adfDeviceObjAll, markObjAll, lmcObjAll, gatewayQty, lightQty, sensorQty, daliCtlQty, zoneControlQty, modbusSlaveQty, adfDeviceQty, markQty, lmcQty, deviceStatus };
    }
    case "FETCHED_LIGHT_OBJ_ALL": {
      return { ...state, lightObjAll: action.payload };
    }
    case "FETCHED_GATEWAY_OBJ_ALL": {
      return { ...state, gatewayObjAll: action.payload };
    }
    case "FETCHED_SENSOR_OBJ_ALL": {
      return { ...state, sensorObjAll: action.payload };
    }
    case "FETCHED_DALICTL_OBJ_ALL": {
      return { ...state, daliCtlObjAll: action.payload };
    }
    case "FETCHED_ZONECONTROL_OBJ_ALL": {
      return { ...state, zoneControlObjAll: action.payload };
    }
    case "FETCHED_TIMETABLE_OBJ_ALL": {
      const { objAll, arrAll } = action.payload;
      return { ...state, timeTableObjAll: objAll, timeTableArrAll: arrAll };
    }
    case "FETCHED_MARK_OBJ_ALL": {
      return { ...state, markObjAll: action.payload };
    }
    case "UPDATE_DEVICE_STATUS": {
      const { deviceID, socketInData } = action.payload;
      state.deviceStatus[deviceID] = { ...state.deviceStatus[deviceID], ...socketInData };
      return { ...state };
    }
    case "SET_ACTIVE_MAP": {
      return {
        ...state,
        activeMapID: action.payload,
      };
    }
    case "SET_ACTIVE_SERIAL": {
      return { ...state, activeSerial: action.payload };
    }
    case "SET_ACTIVE_GATEWAY": {
      return { ...state, activeGatewayID: action.payload };
    }
    case "SET_ACTIVE_SENSOR": {
      return { ...state, activeSensorID: action.payload };
    }
    case "SET_ACTIVE_ZONE_CONTROL": {
      return { ...state, activeZoneControlID: action.payload };
    }
    case "SET_ACTIVE_REPORT": {
      const reportObj = action.payload;
      return {
        ...state,
        activeReportID: reportObj?.reportID || "",
        activeReportObj: reportObj,
      };
    }

    case "UPDATED_USER_OBJ": {
      return { ...state, userObj: action.payload };
    }
    case "UPDATED_MAP_OBJ": {
      const mapObj = action.payload;
      const mapID = mapObj.mapID;
      state.mapObjAll[mapID] = mapObj;
      return { ...state };
    }
    case "UPDATE_DEVICE_OBJ": {
      const { deviceID, deviceType, updateObj } = action.payload;
      if (deviceID === undefined || deviceType === undefined || updateObj === undefined) return { ...state };
      console.log("UPDATE_DEVICE_OBJ", deviceID, deviceType, updateObj);
      let deviceObj = state[`${deviceType}ObjAll`][deviceID];
      if (deviceObj) {
        deviceObj = { ...deviceObj, ...updateObj };
        state[`${deviceType}ObjAll`][deviceID] = deviceObj;
      }
      return { ...state };
    }
    case "UPDATE_LIGHT_OBJ": {
      const lightObj = action.payload;
      const serial = lightObj.serial;
      state.lightObjAll[serial] = lightObj;
      return { ...state };
    }
    case "UPDATE_MULTI_LIGHT_OBJ": {
      const lightObjArray = action.payload;
      lightObjArray.forEach((obj) => {
        state.lightObjAll[obj.serial] = obj;
      });
      return { ...state };
    }
    case "UPDATE_MULTI_DEVICE_OBJ": {
      const { deviceUpdateObjArray, deviceObjArray, deviceType } = action.payload;
      let deviceObjAll = state[`${deviceType}ObjAll`] || {};
      if (deviceObjArray) {
        deviceObjArray.forEach((obj) => {
          const deviceIdField = deviceType === "light" ? "serial" : deviceType + "ID";
          const deviceID = obj[deviceIdField];
          deviceObjAll[deviceID] = obj;
        });
      }
      if (deviceUpdateObjArray) {
        console.log("UPDATE_MULTI_DEVICE_OBJ", deviceUpdateObjArray);
        deviceUpdateObjArray.forEach((obj) => {
          const deviceIdField = deviceType === "light" ? "serial" : deviceType + "ID";
          const deviceID = obj[deviceIdField];
          deviceObjAll[deviceID] = { ...deviceObjAll[deviceID], ...obj };
        });
      }
      state[`${deviceType}ObjAll`] = deviceObjAll;
      return { ...state };
    }
    case "UPDATE_MULTI_DEVICE_OBJ_VAR_TYPE": {
      const deviceUpdateObjArray = action.payload;
      deviceUpdateObjArray.forEach(obj => {
        const { deviceID, deviceType } = obj;
        if (state[`${deviceType}ObjAll`]) {
          let newObj = { ...state[`${deviceType}ObjAll`][deviceID], ...obj };
          state[`${deviceType}ObjAll`][deviceID] = newObj;
        }
      })
      return { ...state };
    }
    case "UPDATE_GATEWAY_OBJ": {
      const gatewayObj = action.payload;
      const gatewayID = gatewayObj?.gatewayID;
      state.gatewayObjAll[gatewayID] = gatewayObj;
      return { ...state };
    }
    case "UPDATE_SENSOR_OBJ": {
      const obj = action.payload;
      if (obj) {
        const sensorID = obj.sensorID;
        state.sensorObjAll[sensorID] = obj;
      }
      return { ...state };
    }
    case "UPDATE_DALICTL_OBJ": {
      const daliCtlObj = action.payload;
      const daliCtlID = daliCtlObj?.daliCtlID;
      state.daliCtlObjAll[daliCtlID] = daliCtlObj;
      return { ...state };
    }
    case "UPDATED_SERVER_OBJ": {
      return { ...state, serverObj: action.payload };
    }
    case "UPDATED_MARK_OBJ": {
      const obj = action.payload;
      const markID = obj.markID;
      state.markObjAll[markID] = obj;
      return { ...state };
    }
    case "UPDATE_DETECTOR_OBJ": {
      const updateObj = action.payload;
      state.detectorObj = { ...state.detectorObj, ...updateObj }
      return { ...state };
    }
    case "LIGHT_DELETE_PERMANENTLY": {
      const serial = action.payload;
      delete state.lightObjAll[serial];
      return { ...state };
    }
    case "UPDATED_ZONE_CONTROL_OBJ": {
      const obj = action.payload;
      if (obj) {
        const zoneControlID = obj.zoneControlID;
        state.zoneControlObjAll[zoneControlID] = obj;
      }
      return { ...state };
    }
    case "UPDATE_LIGHT_CURRENT_DATA": {
      const { serial, serialProps } = action.payload;
      let modifySerialProps = {};
      Object.keys(serialProps).forEach((k) => {
        modifySerialProps[k] = serialProps[k] || "";
      });
      const lightArr = Object.keys(state.lightObjAll || {});
      if (lightArr.includes(serial)) {
        state.lightObjAll[serial] = {
          ...state.lightObjAll[serial],
          ...modifySerialProps,
        };
      }
      return { ...state };
    }
    case "UPDATED_MAP_PROPERTY": {
      const { mapID, updateObj } = action.payload;
      // state.mapObjAll[mapID][field] = value;
      state.mapObjAll[mapID] = { ...state.mapObjAll[mapID], ...updateObj };
      return { ...state };
    }
    case "UPDATED_LIGHT_PROPERTY": {
      const { serial, updateObj } = action.payload;
      state.lightObjAll[serial] = {
        ...state.lightObjAll[serial],
        ...updateObj,
      };
      return { ...state };
    }
    case "UPDATED_LIGHT_TYPE": {
      const { serial, typeField, value } = action.payload;
      if (state.lightObjAll[serial]) {
        if (state.lightObjAll[serial].type) {
          state.lightObjAll[serial].type[typeField] = value;
        }
      };
      return { ...state };
    }
    case "UPDATE_MULTI_SERIAL_PROPERTY": {
      const updateObjBySerial = action.payload;
      Object.keys(updateObjBySerial || {}).forEach((s) => {
        const updateObj = updateObjBySerial[s];
        state.lightObjAll[s] = {
          ...state.lightObjAll[s],
          ...updateObj,
        };
      });
      return { ...state };
    }
    case "UPDATED_SENSOR_PROPERTY": {
      const { sensorID, updateObj } = action.payload;
      // console.log("In reducer UPDATED_SENSOR_PROPERTY", sensorID, updateObj);
      state.sensorObjAll[sensorID] = {
        ...state.sensorObjAll[sensorID],
        ...updateObj,
      };
      return { ...state };
    }
    case "UPDATED_GATEWAY_PROPERTY": {
      const { gatewayID, updateObj } = action.payload;
      const inMap = Object.keys(state.gatewayObjAll || {}).includes(gatewayID);
      const detectorID = state.detectorObj?.gatewayID;
      if (detectorID === gatewayID) {
        state.detectorObj = { ...state.detectorObj, ...updateObj };
      } else if (inMap) {
        state.gatewayObjAll[gatewayID] = {
          ...state.gatewayObjAll[gatewayID],
          ...updateObj,
        };
      }
      return { ...state };
    }
    case "UPDATED_ZC_PROPERTY": {
      const { zoneControlID, updateObj } = action.payload;
      // console.log("UPDATED_ZC_PROPERTY", zoneControlID, updateObj);
      state.zoneControlObjAll[zoneControlID] = {
        ...state.zoneControlObjAll[zoneControlID],
        ...updateObj,
      };
      return { ...state };
    }
    case "UPDATED_DALICTL_PROPERTY": {
      const { daliCtlID, updateObj } = action.payload;
      state.daliCtlObjAll[daliCtlID] = {
        ...state.daliCtlObjAll[daliCtlID],
        ...updateObj,
      };
      return { ...state };
    }
    case "UPDATED_SERVER_PROPERTY": {
      const updateObj = action.payload;
      state.serverObj = { ...state.serverObj, ...updateObj };
      return { ...state };
    }
    case "TEST_TERMINATED": {
      const { serial, reportID } = action.payload;
      state.lightObjAll[serial].reportObj.result = "FAIL";
      return { ...state };
    }
    case "DELETED_ZONE_CONTROL": {
      const zoneControlID = action.payload;
      delete state.zoneControlObjAll[zoneControlID];
      return { ...state };
    }
    case "ADD_ZC_TIME_SETTING": {
      const { zoneControlID, timeTableObj1, timeTableObj2, timeTableObj3 } = action.payload;
      const tid1 = timeTableObj1?.timeTableID;
      const tid2 = timeTableObj2?.timeTableID;
      const tid3 = timeTableObj3?.timeTableID;
      let zoneControlObj = state.zoneControlObjAll[zoneControlID] || {};
      const enableSetting3 = zoneControlObj?.enableSetting3;
      let timeTableID1 = [...(zoneControlObj?.timeTableID1 || [])];
      if (!timeTableID1.includes(tid1)) timeTableID1 = [...timeTableID1, tid1];
      let timeTableID2 = [...(zoneControlObj?.timeTableID2 || [])];
      if (!timeTableID2.includes(tid2)) timeTableID2 = [...timeTableID2, tid2];
      zoneControlObj = { ...zoneControlObj, timeTableID1, timeTableID2 };
      if (enableSetting3) {
        let timeTableID3 = [...(zoneControlObj?.timeTableID3 || [])];
        if (!timeTableID3.includes(tid3)) timeTableID3 = [...timeTableID3, tid3];
        zoneControlObj = { ...zoneControlObj, timeTableID3 };
      }
      state.zoneControlObjAll[zoneControlID] = zoneControlObj;
      state.timeTableObjAll = { ...state.timeTableObjAll, [tid1]: timeTableObj1, [tid2]: timeTableObj2 }
      if (enableSetting3) {
        state.timeTableObjAll = { ...state.timeTableObjAll, [tid3]: timeTableObj3, }
      }
      return { ...state };
    }
    case "UPDATED_TIMETABLE_OBJ": {
      let updateObj = action.payload;
      let newTimeTableObjAll = { ...(state.timeTableObjAll || {}) };
      let newTimeTableArrAll = [...(state.timeTableArrAll || [])];
      const tid = updateObj.timeTableID;
      const newObj = { ...newTimeTableObjAll[tid], ...updateObj };
      const index = newTimeTableArrAll.findIndex(
        (obj) => obj.timeTableID === tid
      );
      if (index !== -1) {
        newTimeTableArrAll[index] = newObj;
        newTimeTableObjAll[tid] = newObj;
      }
      return {
        ...state,
        timeTableArrAll: newTimeTableArrAll,
        timeTableObjAll: newTimeTableObjAll,
      };
    }
    case "UPDATE_MULTI_TIMETABLE_OBJ": {
      const { timeTableObjArray } = action.payload;
      let newTimeTableObjAll = { ...(state.timeTableObjAll || {}) };
      let newTimeTableArrAll = [...(state.timeTableArrAll || [])];
      timeTableObjArray.forEach((obj) => {
        const tid = obj.timeTableID;
        newTimeTableObjAll = { ...newTimeTableObjAll, [tid]: obj };
        const index = newTimeTableArrAll.findIndex(obj => obj.timeTableID === tid);
        if (index === -1) newTimeTableArrAll.push(obj);
        else newTimeTableArrAll[index] = obj;
      });
      return { ...state, timeTableObjAll: newTimeTableObjAll, timeTableArrAll: newTimeTableArrAll };
    }
    case "DELETE_MULTI_TIMETABLE_OBJ": {
      const { timeTableIDArray } = action.payload;
      let newTimeTableObjAll = { ...(state.timeTableObjAll || {}) };
      let newTimeTableArrAll = [...(state.timeTableArrAll || [])];
      timeTableIDArray.forEach(tid => {
        delete newTimeTableObjAll[tid];
        newTimeTableArrAll = newTimeTableArrAll.filter(obj => obj.timeTableID !== tid);
      });
      return { ...state, timeTableObjAll: newTimeTableObjAll, timeTableArrAll: newTimeTableArrAll };
    }
    case "CREATE_SLAVE_LIGHT": {
      const slaveLightObj = action.payload;
      const slaveSerial = slaveLightObj.serial;
      const masterSerial = slaveLightObj.masterSerial;
      let masterLightObj = state.lightObjAll[masterSerial];
      let slaveLightArray = masterLightObj?.slaveLightArray || [];
      if (!slaveLightArray.includes(slaveSerial)) slaveLightArray.push(slaveLightObj.serial);
      if (masterLightObj) masterLightObj.slaveLightArray = slaveLightArray;
      state.lightObjAll = { ...state.lightObjAll, [masterSerial]: masterLightObj, [slaveSerial]: slaveLightObj }
      return state;
    }
    case "DELETE_SLAVE_LIGHT": {
      const slaveLightObj = action.payload;
      const slaveSerial = slaveLightObj.serial;
      const masterSerial = slaveLightObj.masterSerial;
      let masterLightObj = state.lightObjAll[masterSerial];
      let slaveLightArray = masterLightObj?.slaveLightArray || [];
      slaveLightArray = slaveLightArray.filter(s => s !== slaveSerial);
      if (masterLightObj) {
        masterLightObj.slaveLightArray = slaveLightArray;
        state.lightObjAll = { ...state.lightObjAll, [masterSerial]: masterLightObj }
        delete state.lightObjAll[slaveSerial];
      }
      return state;
    }

    ///////////Map Use //////////////////Map Use //////////////////Map Use //////////////////Map Use ///////
    case "SET_MAP_SIZE_SCALE": {
      const { size, scale } = action.payload;
      return { ...state, mapScale: scale, mapSize: size };
    }
    case "SET_RIGHT_CLICK_POS": {
      return { ...state, mapRightClickPos: action.payload };
    }
    case "SET_ENABLE_PAN": {
      let updateObj = { enablePan: action.payload };
      if (action.payload) updateObj = { ...updateObj, enableZoom: "" };
      return { ...state, ...updateObj };
    }
    case "SET_ENABLE_ZOOM": {
      let newEnablePan = action.payload ? false : true;
      return { ...state, enableZoom: action.payload, enablePan: newEnablePan };
    }
    case "SET_MAP_RIGHT_MODE": {
      return { ...state, mapRightMode: action.payload };
    }
    case "SET_MAP_LAYER": {
      const obj = { ...state.mapLayer, ...action.payload };
      return { ...state, mapLayer: obj };
    }
    case "SET_LAYER_SCALE": {
      const { layerScale, layerPos } = action.payload;
      return { ...state, layerScale, layerPos };
    }
    case "SWITCH_CREATE_SLAVE_LIGHT_MODE": {
      return { ...state, createSlaveLightMode: !state.createSlaveLightMode };
    }
    case "OFF_CREATE_SLAVE_LIGHT_MODE": {
      return { ...state, createSlaveLightMode: false };
    }
    case "MAP_ADDED_ZONE_CONTROL": {
      const { zoneControlID, zoneControlObj, mapID, x, y } = action.payload;
      state.zoneControlObjAll[zoneControlID] = zoneControlObj;
      let newZcMapObj = { ...(state.mapObjAll[mapID]?.zoneControlObj || {}) };
      newZcMapObj = { ...newZcMapObj, [zoneControlID]: { x, y } };
      if (state.mapObjAll[mapID]) state.mapObjAll[mapID].zoneControlObj = newZcMapObj;
      return { ...state };
    }
    case "MAP_DELETED_ZONE_CONTROL": {
      const { zoneControlID, mapID } = action.payload;
      let existingZcObj = state.zoneControlObjAll[zoneControlID];
      let serialMap = existingZcObj?.serial || {};
      delete state.zoneControlObjAll[zoneControlID];
      if (mapID) {
        let newZcMapObj = { ...(state.mapObjAll[mapID]?.zoneControlObj || {}) };
        delete newZcMapObj[zoneControlID];
        if (state.mapObjAll[mapID]) state.mapObjAll[mapID].zoneControlObj = newZcMapObj;
      }
      Object.values(serialMap || {}).forEach((s) => {
        let lightObj = state.lightObjAll[s];
        let zcArr = lightObj?.zoneControlArray || [];
        zcArr = zcArr.filter((z) => z !== zoneControlID);
        state.lightObjAll[s].zoneControlArray = zcArr;
      });
      if (existingZcObj?.type === "timer") {
        delete state.timeTableObjAll[existingZcObj.timeTableID1];
        delete state.timeTableObjAll[existingZcObj.timeTableID2];
      }
      return { ...state };
    }
    case "MAP_ADD_DEVICE": {
      const { deviceID, deviceType, deviceObj, mapID, x, y } = action.payload;
      if (Array.isArray(deviceObj.mapID)) {
        let newMapIDArr = [...deviceObj.mapID, mapID];
        deviceObj.mapID = newMapIDArr;
      } else {
        deviceObj.mapID = [deviceObj.mapID, mapID];
      }
      state[`${deviceType}ObjAll`][deviceID] = deviceObj;
      let newMapDeviceObj = state.mapObjAll[mapID]?.[`${deviceType}Obj`] || {};
      newMapDeviceObj = { ...newMapDeviceObj, [deviceID]: { x, y } };
      if (state.mapObjAll[mapID]) state.mapObjAll[mapID][`${deviceType}Obj`] = newMapDeviceObj;
      return { ...state };
    }
    case "MAP_ADD_MANY_DEVICES": {
      const { deviceObjArrayByType, mapID } = action.payload;
      console.log(`[ACTION MAP_ADD_MANY_DEVICES] - deviceObjArrayByType: ${JSON.stringify(deviceObjArrayByType)} - mapID: ${mapID}`);
      Object.keys(deviceObjArrayByType).forEach(deviceType => {
        const deviceObjArray = deviceObjArrayByType[deviceType];
        deviceObjArray.forEach(deviceObj => {
          const idFieldMap = { light: "serial", sensor: "sensorID", gateway: "gatewayID", daliCtl: "daliCtlID", zoneControl: "zoneControlID" };
          const deviceID = deviceObj[idFieldMap[deviceType]];
          console.log(`[ACTION MAP_ADD_MANY_DEVICES] ${deviceType} - ${deviceID} update objAll`)
          state[`${deviceType}ObjAll`][deviceID] = deviceObj;
        });
      });
      return { ...state };
    }
    case "MAP_REMOVE_DEVICE": {
      const { deviceID, deviceType, mapID } = action.payload;
      console.log(`[ACTION MAP_REMOVE_DEVICE] - deviceID: ${deviceID} - deviceType: ${deviceType} - mapID: ${mapID}`);
      if (!deviceID || !deviceType || !mapID) return { ...state };
      delete state[`${deviceType}ObjAll`][deviceID];
      if (state.mapObjAll[mapID]) {
        let newMapDeviceObj = state.mapObjAll[mapID]?.[`${deviceType}Obj`];
        if (newMapDeviceObj) delete newMapDeviceObj[deviceID];
        state.mapObjAll[mapID][`${deviceType}Obj`] = newMapDeviceObj;
      }
      return { ...state };
    }
    case "MAP_REMOVE_MANY_DEVICES": {
      const { deviceArrayObj, mapID } = action.payload;
      const deviceTypeArray = ["light", "sensor", "gateway", "daliCtl", "zoneControl"];
      console.log(`[ACTION MAP_REMOVE_MANY_DEVICES] - deviceArrayObj: ${JSON.stringify(deviceArrayObj)} - mapID: ${mapID}`);
      deviceTypeArray.forEach(deviceType => {
        const deviceIDArray = deviceArrayObj[`${deviceType}Array`];
        (deviceIDArray || []).forEach(deviceID => {
          delete state[`${deviceType}ObjAll`][deviceID];
          if (state.mapObjAll[mapID]) {
            let newMapDeviceObj = state.mapObjAll[mapID]?.[`${deviceType}Obj`];
            if (newMapDeviceObj) {
              delete newMapDeviceObj[deviceID];
              state.mapObjAll[mapID][`${deviceType}Obj`] = newMapDeviceObj;
            }
          }
        });
      });
      return { ...state };
    }
    case "MAP_REMOVE_DEVICE_BY_ID": {
      const { mongoDocID, deviceType, deviceIDField, mapID } = action.payload;
      const objArray = Object.keys(state[`${deviceType}ObjAll`] || {}).map(mid => state[`${deviceType}ObjAll`][mid]);
      console.log("[MAP_REMOVE_DEVICE_BY_ID] -objArray", objArray);
      const foundObj = objArray.find(obj => obj["_id"] === mongoDocID);
      console.log("[MAP_REMOVE_DEVICE_BY_ID] -foundObj", foundObj);
      if (foundObj) {
        const deviceID = foundObj[deviceIDField];
        delete state[`${deviceType}ObjAll`][deviceID];
        let newMapDeviceObj = state.mapObjAll[mapID]?.[`${deviceType}Obj`];
        delete newMapDeviceObj[deviceID];
        if (state.mapObjAll[mapID]) state.mapObjAll[mapID][`${deviceType}Obj`] = newMapDeviceObj;
      }
      return { ...state };
    }
    case "SET_MAP_DEVICE_MESSAGE": {
      const { mapDeviceMessage, mapDeviceMessageArray } = action.payload;
      return { ...state, mapDeviceMessage, mapDeviceMessageArray };
    }
    case "DEVICE_SELECTED": {
      const {
        deviceID,
        deviceType,
        deviceObj,
        mapRightMode,
        x,
        y,
        layerScale,
      } = action.payload;
      let obj = {
        selectedID: deviceID,
        selectedDeviceType: deviceType,
        selectedDeviceObj: deviceObj,
        selectedDeviceX: x,
        selectedDeviceY: y,
      };
      if (mapRightMode) obj = { ...obj, mapRightMode };
      if (layerScale) obj = { ...obj, layerScale };
      return {
        ...state,
        ...obj,
        mapItemHideFilter: [],
        hideDeviceToolbar: false,
      };
    }
    case "DEVICE_MOVED": {
      const { mapID, deviceType, deviceID, x, y } = action.payload;
      let mapDeviceObj =
        { ...state.mapObjAll[mapID][`${deviceType}Obj`] } || {};
      mapDeviceObj = { ...mapDeviceObj, [deviceID]: { x: x, y: y } };
      state.mapObjAll[mapID][`${deviceType}Obj`] = mapDeviceObj;
      return { ...state };
    }
    case "SET_SELECTED_GATEWAY": {
      return { ...state, selectedGatewayID: action.payload };
    }
    case "SET_SELECTED_SENSOR": {
      return { ...state, selectedSensorID: action.payload };
    }
    case "SELECTED_MULTI": {
      const newObj = action.payload;
      const deviceID = newObj.deviceID;
      const idArray = state.selectMultiArray.map((obj) => obj.deviceID);
      let newArray = [...state.selectMultiArray];
      if (!idArray?.includes(deviceID)) {
        newArray = [...newArray, newObj];
      } else {
        newArray = newArray.filter((obj) => obj.deviceID !== deviceID);
      }
      return { ...state, selectMultiArray: newArray };
    }
    case "SELECT_MULTI_CLEAR": {
      return { ...state, selectMultiArray: [] };
    }
    case "OPEN_DEVICE_DETAIL_MODAL": {
      const { deviceID, idField } = action.payload;
      return { ...state, [idField]: deviceID };
    }
    case "CLOSE_DEVICE_DETAIL_MODAL": {
      const { idField } = action.payload;
      const activeIdField = "active" + idField.charAt(0).toUpperCase() + idField.slice(1);
      return { ...state, [activeIdField]: "" };
    }
    case "OPENED_LIGHT_DETAIL_MODAL": {
      return {
        ...state, activeSerial: action.payload,
      };
    }
    case "CLOSED_LIGHT_DETAIL_MODAL": {
      return {
        ...state, activeSerial: "",
      };
    }
    case "OPENED_SENSOR_DETAIL_MODAL": {
      return {
        ...state,
        activeSensorID: action.payload,
      };
    }
    case "CLOSED_SENSOR_DETAIL_MODAL": {
      return { ...state, activeSensorID: "" };
    }
    case "OPENED_GATEWAY_DETAIL_MODAL": {
      return {
        ...state, activeGatewayID: action.payload,
      };
    }
    case "CLOSED_GATEWAY_DETAIL_MODAL": {
      return { ...state, activeGatewayID: "" };
    }
    case "OPENED_GATEWAY_ADVANCE_HISTORY_MODAL": {
      return {
        ...state,
        activeGatewayID: action.payload,
        openGatewayAdvanceHistoryMordal: true,
      };
    }
    case "CLOSED_GATEWAY_ADVANCE_HISTORY_MODAL": {
      return { ...state, openGatewayAdvanceHistoryMordal: false };
    }
    case "OPENED_ZC_DETAIL_MODAL": {
      return {
        ...state,
        activeZoneControlID: action.payload,
      };
    }
    case "CLOSED_ZC_DETAIL_MODAL": {
      return {
        ...state,
        activeZoneControlID: "",
      };
    }
    case "OPENED_DALICTL_DETAIL_MODAL": {
      return {
        ...state,
        activeDaliCtlID: action.payload,
      };
    }
    case "CLOSED_DALICTL_DETAIL_MODAL": {
      return { ...state, activeDaliCtlID: "" };
    }
    case "IMAGE_UPLOADED": {
      return { ...state, uploadedImgUrl: action.payload };
    }
    case "CLEARED_UPLOADED_IMAGE": {
      return { ...state, uploadedImgUrl: "" };
    }
    case "DALI_REPLIED_GENERAL_QUERY": {
      const { daliCtlID, daliCmd, shortAdd, reply } = action.payload;
      if (state.daliCtlObjAll[daliCtlID]) {
        state.daliCtlObjAll[daliCtlID].daliReply = { daliCmd, shortAdd, reply };
      }
      return { ...state };
    }
    case "CLEARED_DALI_REPLY": {
      const daliCtlID = action.payload;
      state.daliCtlObjAll[daliCtlID].daliReply = {};
      return { ...state };
    }
    case "GOT_LATEST_FIRMWARE_VERSION": {
      const ver = action.payload;
      let serverObj = { ...state.serverObj, latestFirmwareVer: ver };
      return { ...state, serverObj };
    }

    case "ADD_JOB_PROGRESS": {
      const newProgressArr = action.payload;
      state.jobProgressArray = [...state.jobProgressArray, ...newProgressArr];
      return { ...state };
    }
    case "UPDATE_JOB_PROGRESS": {
      const { jobID, process } = action.payload;
      state.jobProgressArray = state.jobProgressArray.map(jp => jp.jobID === jobID ? { ...jp, process } : jp);
      return { ...state };
    }
    case "ADD_PROGRESS_QUEUE": {
      const queueID = action.payload;
      state.progressQueue = [...(state.progressQueue || []), queueID];
      if (state.progressQueue.length === 1) {
        eventEmitter.emit(queueID);
      }
      return { ...state };
    }
    case "REMOVE_PROGRESS_QUEUE": {
      const queueID = action.payload;
      state.progressQueue = (state.progressQueue || []).filter(q => q !== queueID);
      if (state.progressQueue?.length > 0) {
        eventEmitter.emit(state.progressQueue[0]);
      } else if (state.progressQueue?.length === 0) {

      }
      return { ...state };
    }
    case "DALI_UPDATE_SENSOR": {
      const { daliCtlID, sensorID, sensorType } = action.payload;
      if (state.sensorObjAll[sensorID])
        state.sensorObjAll[sensorID].type = sensorType;
      if (state.daliCtlObjAll[daliCtlID])
        state.daliCtlObjAll[daliCtlID].sensorObj[sensorID].type = sensorType;
      return { ...state };
    }
    case "GATEWAY_CONNECT_LIGHT": {
      const { newLightObj, newGatewayObj, oldGatewayObj, sensorUpdateObjArr } =
        action.payload;
      const { serial } = newLightObj;
      if (state.gatewayObjAll) {
        console.log("GATEWAY CONNECT LIGHT update new gatewayObj", newGatewayObj);
        state.gatewayObjAll[newGatewayObj.gatewayID] = newGatewayObj;
        if (oldGatewayObj.gatewayID) {
          console.log("GATEWAY CONNECT LIGHT update old gatewayObj", oldGatewayObj);
          state.gatewayObjAll[oldGatewayObj.gatewayID] = oldGatewayObj;
        }
      }
      state.lightObjAll[serial] = newLightObj;
      (sensorUpdateObjArr || []).forEach((obj) => {
        const sensorID = obj.sensorID;
        state.sensorObjAll[sensorID] = {
          ...state.sensorObjAll[sensorID],
          ...obj,
        };
      });
      console.log("GATEWAY CONNECT LIGHT updated state", state);
      return { ...state };
    }
    case "GATEWAY_DISCONNECT_LIGHT": {
      const { gatewayObj, newLightObj, sensorUpdateObjArr } = action.payload;
      const { serial } = newLightObj;
      if (state.gatewayObjAll) {
        state.gatewayObjAll[gatewayObj.gatewayID] = gatewayObj;
      }
      state.lightObjAll[serial] = newLightObj;
      (sensorUpdateObjArr || []).forEach((obj) => {
        const sensorID = obj.sensorID;
        state.sensorObjAll[sensorID] = {
          ...state.sensorObjAll[sensorID],
          ...obj,
        };
      });
      return { ...state };
    }
    case "GATEWAY_CONNECT_SENSOR": {
      const { newSensorObj, newGatewayObj, oldGatewayObj, sensorUpdateObjArr } =
        action.payload;
      const { sensorID } = newSensorObj;
      const newGatewayID = newGatewayObj.gatewayID;
      const oldGatewayID = oldGatewayObj.gatewayID;
      if (state.gatewayObjAll) {
        if (newGatewayID) state.gatewayObjAll[newGatewayID] = newGatewayObj;
        if (oldGatewayID) state.gatewayObjAll[oldGatewayID] = oldGatewayObj;
      }
      if (sensorID) state.sensorObjAll[sensorID] = newSensorObj;
      (sensorUpdateObjArr || []).forEach((obj) => {
        const sensorID = obj.sensorID;
        state.sensorObjAll[sensorID] = {
          ...state.sensorObjAll[sensorID],
          ...obj,
        };
      });
      return { ...state };
    }
    case "GATEWAY_DISCONNECT_SENSOR": {
      const { gatewayObj, newSensorObj, sensorUpdateObjArr } = action.payload;
      const { sensorID } = newSensorObj;
      const gatewayID = gatewayObj.gatewayID;
      if (state.gatewayObjAll) {
        if (gatewayID) state.gatewayObjAll[gatewayID] = gatewayObj;
      }
      if (sensorID) state.sensorObjAll[sensorID] = newSensorObj;
      (sensorUpdateObjArr || []).forEach((obj) => {
        const sensorID = obj.sensorID;
        state.sensorObjAll[sensorID] = {
          ...state.sensorObjAll[sensorID],
          ...obj,
        };
      });
      return { ...state };
    }
    case "GATEWAY_CONNECT_DALICTL": {
      const {
        newGwUpdateObj,
        oldGwUpdateObj,
        daliCtlUpdateObj,
        sensorUpdateObjArr,
      } = action.payload;
      const newGwID = newGwUpdateObj?.gatewayID;
      const oldGwID = oldGwUpdateObj?.gatewayID;
      const daliCtlID = daliCtlUpdateObj?.daliCtlID;
      if (newGwID)
        state.gatewayObjAll[newGwID] = {
          ...state.gatewayObjAll[newGwID],
          ...newGwUpdateObj,
        };
      if (oldGwID)
        state.gatewayObjAll[oldGwID] = {
          ...state.gatewayObjAll[oldGwID],
          ...oldGwUpdateObj,
        };
      if (daliCtlID) {
        let daliCtlObj = state.daliCtlObjAll[daliCtlID] || {};
        daliCtlObj = { ...daliCtlObj, ...daliCtlUpdateObj };
        state.daliCtlObjAll[daliCtlID] = daliCtlObj;
        const serialArray = Object.keys(daliCtlObj.lightObj || {});
        serialArray.forEach((s) => {
          state.lightObjAll[s] = {
            ...state.lightObjAll[s],
            gatewayID: newGwID,
          };
        });
      }
      (sensorUpdateObjArr || []).forEach((obj) => {
        const sensorID = obj.sensorID;
        state.sensorObjAll[sensorID] = {
          ...state.sensorObjAll[sensorID],
          ...obj,
        };
      });
      return { ...state };
    }
    case "GATEWAY_DISCONNECT_DALICTL": {
      const { oldGatewayUpdateObj, daliCtlUpdateObj, sensorUpdateObjArr } =
        action.payload;
      const gatewayID = oldGatewayUpdateObj?.gatewayID;
      const daliCtlID = daliCtlUpdateObj?.daliCtlID;
      let daliCtlObj = state.daliCtlObjAll[daliCtlID] || {};
      daliCtlObj = { ...daliCtlObj, ...daliCtlUpdateObj };
      state.daliCtlObjAll[daliCtlID] = daliCtlObj;
      const serialArray = Object.keys(daliCtlObj.lightObj || {});
      serialArray.forEach((s) => {
        state.lightObjAll[s] = {
          ...state.lightObjAll[s],
          gatewayID: "",
        };
      });
      if (gatewayID)
        state.gatewayObjAll[gatewayID] = {
          ...state.gatewayObjAll[gatewayID],
          ...oldGatewayUpdateObj,
        };
      (sensorUpdateObjArr || []).forEach((obj) => {
        const sensorID = obj.sensorID;
        state.sensorObjAll[sensorID] = {
          ...state.sensorObjAll[sensorID],
          ...obj,
        };
      });
      return { ...state };
    }
    case "GATEWAY_REPORT_DEVICE_STATUS": {
      const { gatewayID, gwUpdateObj, deviceUpdateObjArr } = action.payload;
      let gatewayObj = state.gatewayObjAll[gatewayID];
      if (gatewayObj) {
        gatewayObj = { ...gatewayObj, ...gwUpdateObj };
        state.gatewayObjAll[gatewayID] = gatewayObj;
      }
      (deviceUpdateObjArr || []).forEach((obj) => {
        const deviceType = obj.deviceType;
        if (deviceType === "light" && state.lightObjAll[obj.serial]) {
          state.lightObjAll[obj.serial] = { ...state.lightObjAll[obj.serial], ...obj };
        }
        else if (deviceType === "sensor" && state.sensorObjAll[obj.sensorID]) {
          state.sensorObjAll[obj.sensorID] = { ...state.sensorObjAll[obj.sensorID], ...obj };
        }
        else if (deviceType === "daliCtl" && state.daliCtlObjAll[obj.daliCtlID]) {
          state.daliCtlObjAll[obj.daliCtlID] = { ...state.daliCtlObjAll[obj.daliCtlID], ...obj };
        }
      })
      return { ...state };
    }
    case "GATEWAY_REPORT_SURVIVAL": {
      const { gwUpdateObj, deviceUpdateObjArr } = action.payload;
      const gatewayID = gwUpdateObj?.gatewayID;
      let gatewayObj = state.gatewayObjAll[gatewayID]
      if (gatewayObj) {
        gatewayObj = { ...gatewayObj, ...gwUpdateObj };
        state.gatewayObjAll[gatewayID] = gatewayObj;
      }
      for (let updateObj of (deviceUpdateObjArr || [])) {
        const { deviceType } = updateObj;
        const deviceIDField = deviceType === "light" ? "serial" : deviceType + "ID";
        let deviceObj = state[`${deviceType}ObjAll`][deviceIDField];
        if (deviceObj) {
          deviceObj = { ...deviceObj, ...updateObj };
          state[`${deviceType}ObjAll`][deviceIDField] = deviceObj;
        }
      };
      return { ...state };
    }
    case "ALL_GATEWAY_DELETE_UNKNOWN_DEVICE": {
      const { dtkAdd, gatewayIDArray } = action.payload;
      gatewayIDArray.forEach((gatewayID) => {
        let gatewayObj = state.gatewayObjAll[gatewayID];
        if (gatewayObj) {
          let unknownDtkDevice = gatewayObj?.unknownDtkDevice || {};
          delete unknownDtkDevice[dtkAdd];
          if (Object.keys(unknownDtkDevice).length === 0) unknownDtkDevice = {};
          state.gatewayObjAll[gatewayID] = { ...gatewayObj, unknownDtkDevice };
        }
      });
      return { ...state };
    }
    // case "DALI_ADD_LIGHT": {
    //   const { daliCtlID, serial, shortAdd } = action.payload;
    //   state.daliCtlObjAll[daliCtlID].lightObj[serial] = {
    //     connect: false,
    //     serial,
    //     shortAdd,
    //   };
    //   return { ...state };
    // }
    case "DALI_DELETE_LIGHT": {
      const { daliCtlID, serial, shortAdd } = action.payload;
      let lightObj = state.daliCtlObjAll[daliCtlID].lightObj;
      delete lightObj[serial];
      state.daliCtlObjAll[daliCtlID].lightObj = lightObj;
      return { ...state };
    }
    case "DALI_ADD_SENSOR": {
      const { daliCtlID, sensorID, shortAdd, instance, sensorType } =
        action.payload;
      state.daliCtlObjAll[daliCtlID].sensorObj[sensorID] = {
        connect: false,
        sensorID,
        shortAdd,
        instance,
        type: sensorType,
      };
      return { ...state };
    }
    case "DALI_DELETE_SENSOR": {
      const { daliCtlID, sensorID, shortAdd, instance } = action.payload;
      let sensorObj = state.daliCtlObjAll[daliCtlID].sensorObj;
      delete sensorObj[sensorID];
      state.daliCtlObjAll[daliCtlID].sensorObj = sensorObj;
      return { ...state };
    }
    case "DALI_DELETE_ALL_LIGHTS": {
      const { daliCtlID } = action.payload;
      state.daliCtlObjAll[daliCtlID].lightObj = {};
      return { ...state };
    }
    case "DALICTL_CONVERT_TO_LIGHT": {
      const { lightObj, daliCtlID } = action.payload;
      const serial = lightObj.serial;
      state.lightObjAll[serial] = lightObj;
      delete state.daliCtlObjAll[daliCtlID];
      state.activeDaliCtlID = "";
      return { ...state };
    }
    case "LIGHT_CONVERT_TO_DALICTL": {
      const { serial, daliCtlObj } = action.payload;
      const daliCtlID = daliCtlObj.daliCtlID;
      state.daliCtlObjAll[daliCtlID] = daliCtlObj;
      delete state.lightObjAll[serial];
      state.activeSerial = "";
      return { ...state };
    }
    case "UPDATE_MANY_TIMETABLES": {
      const { updateObjArray } = action.payload;
      updateObjArray.forEach((obj) => {
        let ttObj = state.timeTableObjAll[obj.timeTableID] || {};
        ttObj = { ...ttObj, ...obj };
        state.timeTableObjAll[obj.timeTableID] = ttObj;
      });
      return { ...state };
    }
    case "DELETE_ZC_TIME_SETTING": {
      const { zoneControlID, zcUpdateObj, timeTableID1, timeTableID2 } =
        action.payload;
      state.zoneControlObjAll[zoneControlID] = {
        ...state.zoneControlObjAll[zoneControlID],
        ...zcUpdateObj,
      };
      delete state.timeTableObjAll[timeTableID1];
      delete state.timeTableObjAll[timeTableID2];
      return { ...state };
    }
    case "FETCHED_MANY_TIMETABLE_OBJ": {
      const objAll = action.payload;
      Object.keys(objAll || {}).forEach((tid) => {
        state.timeTableObjAll[tid] = objAll[tid];
      });
      return { ...state };
    }
    case "ZC_CONNECT_LIGHT": {
      const { zoneControlID, newZoneControlObj, serial } = action.payload;
      state.zoneControlObjAll[zoneControlID] = newZoneControlObj;
      let zcArr = state.lightObjAll[serial]?.zoneControlArray || [];
      if (!zcArr.includes(zoneControlID)) zcArr = [...zcArr, zoneControlID];
      if (state.lightObjAll[serial]) state.lightObjAll[serial].zoneControlArray = zcArr;
      return { ...state };
    }
    case "ZC_CONNECT_MANY_DEVICES": {
      const { zoneControlID, updateZcObj, deviceUpdateObjArray } = action.payload;
      state.zoneControlObjAll[zoneControlID] = { ...state.zoneControlObjAll[zoneControlID], ...updateZcObj };
      deviceUpdateObjArray.forEach((deviceUpdateObj) => {
        const { deviceType } = deviceUpdateObj;
        if (deviceType === "light") {
          state.lightObjAll[deviceUpdateObj.serial] = { ...state.lightObjAll[deviceUpdateObj.serial], ...deviceUpdateObj };
          state = addMapDeviceMessage(state, [zoneControlID, deviceUpdateObj.serial], [`Connected light ${deviceUpdateObj.serial}`, `Connected zone control ${zoneControlID}`]);
        }
        else if (deviceType === "sensor") {
          state.sensorObjAll[deviceUpdateObj.sensorID] = { ...state.sensorObjAll[deviceUpdateObj.sensorID], ...deviceUpdateObj };
          state = addMapDeviceMessage(state, [zoneControlID, deviceUpdateObj.sensorID], [`Connected sensor ${deviceUpdateObj.sensorID}`, `Connected zone control ${zoneControlID}`]);
        } else if (deviceType === "daliCtl") {
          state.daliCtlObjAll[deviceUpdateObj.daliCtlID] = { ...state.daliCtlObjAll[deviceUpdateObj.daliCtlID], ...deviceUpdateObj };
          state = addMapDeviceMessage(state, [zoneControlID, deviceUpdateObj.daliCtlID], [`Connected daliCtl ${deviceUpdateObj.daliCtlID}`, `Connected zone control ${zoneControlID}`]);
        }
      });
      return { ...state };
    }
    case "ZC_DISCONNECT_MANY_DEVICES": {
      const { zoneControlID, zcUpdateObj, updatedDeviceObjArray } = action.payload;
      state.zoneControlObjAll[zoneControlID] = { ...state.zoneControlObjAll[zoneControlID], ...zcUpdateObj };
      updatedDeviceObjArray.forEach((deviceObj) => {
        const { deviceType } = deviceObj;
        if (deviceType === "light") {
          state.lightObjAll[deviceObj.serial] = { ...state.lightObjAll[deviceObj.serial], ...deviceObj };
          state = addMapDeviceMessage(state, [zoneControlID, deviceObj.serial], [`Disconnected light ${deviceObj.serial}`, `Disconnected zone control ${zoneControlID}`]);
        }
        else if (deviceType === "sensor") {
          state.sensorObjAll[deviceObj.sensorID] = { ...state.sensorObjAll[deviceObj.sensorID], ...deviceObj };
          state = addMapDeviceMessage(state, [zoneControlID, deviceObj.sensorID], [`Disconnected sensor ${deviceObj.sensorID}`, `Disconnected zone control ${zoneControlID}`]);
        } else if (deviceType === "daliCtl") {
          state.daliCtlObjAll[deviceObj.daliCtlID] = { ...state.daliCtlObjAll[deviceObj.daliCtlID], ...deviceObj };
          state = addMapDeviceMessage(state, [zoneControlID, deviceObj.daliCtlID], [`Disconnected daliCtl ${deviceObj.daliCtlID}`, `Disconnected zone control ${zoneControlID}`]);
        }
      });
      return { ...state };
    }
    case "ZC_DISCONNECT_LIGHT": {
      const { zoneControlID, newZoneControlObj, serial } = action.payload;
      state.zoneControlObjAll[zoneControlID] = newZoneControlObj;
      let zcArr = state.lightObjAll[serial]?.zoneControlArray || [];
      zcArr = zcArr.filter((z) => z !== zoneControlID);
      if (state.lightObjAll) {
        if (state.lightObjAll[serial]) {
          state.lightObjAll[serial].zoneControlArray = zcArr;
        }
      }
      return { ...state };
    }
    case "ZC_DISCONNECT_ALL_DEVICES": {
      const zoneControlObj = action.payload;
      const { zoneControlID, serialMap, sensorMap, daliCtlMap } = zoneControlObj || {};
      Object.values(serialMap || {}).forEach((s) => {
        let arr = state.lightObjAll[s]?.zoneControlArray || [];
        arr = arr.filter((z) => z !== zoneControlID);
        if (state.lightObjAll[s]) state.lightObjAll[s].zoneControlArray = arr;
      });
      Object.values(sensorMap || {}).forEach((s) => {
        let arr = state.sensorObjAll[s]?.zoneControlArray || [];
        arr = arr.filter((z) => z !== zoneControlID);
        if (state.sensorObjAll[s]) state.sensorObjAll[s].zoneControlArray = arr;
      });
      Object.values(daliCtlMap || {}).forEach((s) => {
        let arr = state.daliCtlObjAll[s]?.zoneControlArray || [];
        arr = arr.filter((z) => z !== zoneControlID);
        if (state.daliCtlObjAll[s]) state.daliCtlObjAll[s].zoneControlArray = arr;
      });
      return { ...state };
    }
    case "ZC_CONNECT_SENSOR": {
      const { zoneControlID, newZoneControlObj, sensorID } = action.payload;
      state.zoneControlObjAll[zoneControlID] = newZoneControlObj;
      let zcArr = state.sensorObjAll[sensorID]?.zoneControlArray || [];
      if (!zcArr.includes(zoneControlID)) zcArr = [...zcArr, zoneControlID];
      if (state.sensorObjAll[sensorID])
        state.sensorObjAll[sensorID].zoneControlArray = zcArr;
      return { ...state };
    }
    case "ZC_DISCONNECT_SENSOR": {
      const { zoneControlID, newZoneControlObj, sensorID } = action.payload;
      state.zoneControlObjAll[zoneControlID] = newZoneControlObj;
      let zcArr = state.sensorObjAll[sensorID]?.zoneControlArray || [];
      zcArr = zcArr.filter((z) => z !== zoneControlID);
      if (state.sensorObjAll[sensorID])
        state.sensorObjAll[sensorID].zoneControlArray = zcArr;
      return { ...state };
    }
    case "TRANSFER_ZC_SETTINGS": {
      const { sourceObj, targetObj, timeTableObjArray } = action.payload;
      const targetID = targetObj.zoneControlID;
      state.zoneControlObjAll[targetID] = targetObj;
      Object.values(targetObj.serialMap || {}).forEach(serial => {
        let lightObj = state.lightObjAll[serial];
        let zoneControlArray = lightObj?.zoneControlArray || [];
        if (!zoneControlArray.includes(targetID)) zoneControlArray = [...zoneControlArray, targetID];
        if (lightObj) lightObj.zoneControlArray = zoneControlArray;
      });
      Object.values(targetObj.sensorMap || {}).forEach(sensorID => {
        let sensorObj = state.sensorObjAll[sensorID];
        let zoneControlArray = sensorObj?.zoneControlArray || [];
        if (!zoneControlArray.includes(targetID)) zoneControlArray = [...zoneControlArray, targetID];
        if (sensorObj) sensorObj.zoneControlArray = zoneControlArray;
      });
      let currentTimeTableIDArrAll = state.timeTableArrAll.map(obj => obj.timeTableID);
      timeTableObjArray.forEach(obj => {
        if (currentTimeTableIDArrAll.includes(obj.timeTableID)) return;
        state.timeTableArrAll = [...state.timeTableArrAll, obj];
        state.timeTableObjAll[obj.timeTableID] = obj;
      });
      return { ...state };
    }
    case "SENSOR_CONNECT_LIGHT": {
      const { newSensorObj, lightObj } = action.payload;
      const sensorID = newSensorObj.sensorID;
      const { serial, dtkAdd } = lightObj;
      let lightWifiApMacAddress = lightObj.wifiApMacAddress;
      if (lightObj.daliCtlID) {
        const lightDaliCtlObj = state.daliCtlObjAll[lightObj.daliCtlID];
        lightWifiApMacAddress = lightDaliCtlObj.wifiApMacAddress;
      }
      let sensorArray = state.lightObjAll[serial]?.sensorArray || [];
      if (!sensorArray.includes(sensorID)) sensorArray = [...sensorArray, sensorID];
      state.lightObjAll[serial].sensorArray = sensorArray;
      let sensorObj = { ...state.sensorObjAll[sensorID] };
      let serialMap = { ...(sensorObj.serialMap || {}) };
      if (!lightObj.daliCtlID) serialMap = { ...serialMap, [dtkAdd]: serial };
      else serialMap = { ...serialMap, [serial]: serial };
      sensorObj = { ...sensorObj, serialMap };
      const repliedNearFieldSetting = newSensorObj.nearFieldSetting || {};
      let nearFieldSetting = { ...(sensorObj.nearFieldSetting || {}) };
      for (let i = 1; i < 13; i++) {
        let setting = sensorObj[`setting${i}`] || {};
        const updatedDeviceSetting = newSensorObj[`setting${i}`]?.[serial];
        if (updatedDeviceSetting) setting = { ...setting, [serial]: updatedDeviceSetting }
        sensorObj = { ...sensorObj, [`setting${i}`]: setting };
        const lightNearFieldAdded = repliedNearFieldSetting[`setting${i}`]?.includes(lightWifiApMacAddress);
        if (lightNearFieldAdded) {
          nearFieldSetting[`setting${i}`] = [...(nearFieldSetting[`setting${i}`] || []), lightWifiApMacAddress];
        }
        sensorObj = { ...sensorObj, [`setting${i}`]: setting };
      }
      sensorObj = { ...sensorObj, nearFieldSetting };
      state.sensorObjAll[sensorID] = sensorObj;
      return { ...state };
    }
    case "SENSOR_CONNECT_SENSOR": {
      const { newMainSensorObj, newControlledSensorObj } = action.payload;
      const mainSensorID = newMainSensorObj.sensorID;
      const controlledSensorID = newControlledSensorObj.sensorID;
      const controlledSensorMacAddress = newControlledSensorObj.wifiApMacAddress;
      let mainSensorObj = state.sensorObjAll[mainSensorID];
      let controlledSensorObj = state.sensorObjAll[controlledSensorID];
      let sensorArray = controlledSensorObj?.sensorArray || [];
      if (!sensorArray.includes(mainSensorID)) sensorArray = [...sensorArray, mainSensorID];
      controlledSensorObj.sensorArray = sensorArray;
      state.sensorObjAll[controlledSensorID] = controlledSensorObj;
      let mainSensorMap = { ...(mainSensorObj.sensorMap || {}) };
      mainSensorMap = { ...mainSensorMap, [controlledSensorObj.dtkAdd]: controlledSensorID };
      mainSensorObj = { ...mainSensorObj, sensorMap: mainSensorMap };
      const repliedNearFieldSetting = newMainSensorObj.nearFieldSetting || {};
      let nearFieldSetting = { ...(mainSensorObj.nearFieldSetting || {}) };
      for (let i = 1; i < 13; i++) {
        let setting = mainSensorObj[`setting${i}`] || {};
        const updatedDeviceSetting = newMainSensorObj[`setting${i}`]?.[controlledSensorID];
        if (updatedDeviceSetting) setting = { ...setting, [controlledSensorID]: updatedDeviceSetting }
        mainSensorObj = { ...mainSensorObj, [`setting${i}`]: setting };
        const controlledSensorNearFieldAdded = repliedNearFieldSetting[`setting${i}`]?.includes(controlledSensorMacAddress);
        if (controlledSensorNearFieldAdded) {
          nearFieldSetting[`setting${i}`] = [...(nearFieldSetting[`setting${i}`] || []), controlledSensorMacAddress];
        }
        mainSensorObj = { ...mainSensorObj, [`setting${i}`]: setting };
      }
      mainSensorObj = { ...mainSensorObj, nearFieldSetting };
      state.sensorObjAll[mainSensorID] = mainSensorObj;
      return { ...state };
    }
    case "SENSOR_CONNECT_DALICTL": {
      const { newSensorObj, newDaliCtlObj } = action.payload;
      const sensorID = newSensorObj.sensorID;
      const daliCtlID = newDaliCtlObj.daliCtlID;
      const daliCtlDtkAdd = newDaliCtlObj.dtkAdd;
      const daliCtlMacAddress = newDaliCtlObj.wifiApMacAddress;
      let sensorArray = state.daliCtlObjAll[daliCtlID]?.sensorArray || [];
      if (!sensorArray.includes(sensorID)) sensorArray = [...sensorArray, sensorID];
      state.daliCtlObjAll[daliCtlID].sensorArray = sensorArray;
      let sensorObj = { ...state.sensorObjAll[sensorID] };
      const daliCtlMap = { ...(sensorObj.daliCtlMap || {}), [daliCtlDtkAdd]: daliCtlID }
      sensorObj = { ...sensorObj, daliCtlMap };
      const repliedNearFieldSetting = newSensorObj.nearFieldSetting || {};
      let nearFieldSetting = { ...(sensorObj.nearFieldSetting || {}) };
      for (let i = 1; i < 13; i++) {
        let setting = sensorObj[`setting${i}`] || {};
        const updatedDeviceSetting = newSensorObj[`setting${i}`]?.[daliCtlID];
        if (updatedDeviceSetting) setting = { ...setting, [daliCtlID]: updatedDeviceSetting }
        sensorObj = { ...sensorObj, [`setting${i}`]: setting };
        const daliCtlNearFieldAdded = repliedNearFieldSetting[`setting${i}`]?.includes(daliCtlMacAddress);
        if (daliCtlNearFieldAdded) {
          nearFieldSetting[`setting${i}`] = [...(nearFieldSetting[`setting${i}`] || []), daliCtlMacAddress];
        }
        sensorObj = { ...sensorObj, [`setting${i}`]: setting };
      }
      sensorObj = { ...sensorObj, nearFieldSetting };
      state.sensorObjAll[sensorID] = sensorObj;
      return state;
    }
    case "SENSOR_DISCONNECT_LIGHT": {
      const { lightObj, newSensorObj } = action.payload;
      const { serial, dtkAdd } = lightObj;
      let lightWifiApMacAddress = lightObj.wifiApMacAddress;
      if (lightObj.daliCtlID) {
        const lightDaliCtlObj = state.daliCtlObjAll[lightObj.daliCtlID];
        lightWifiApMacAddress = lightDaliCtlObj.wifiApMacAddress;
      }
      const sensorID = newSensorObj.sensorID;
      let arr = state.lightObjAll[serial]?.sensorArray || [];
      arr = arr.filter((sen) => sen !== sensorID);
      if (state.lightObjAll[serial]) state.lightObjAll[serial].sensorArray = arr;
      let sensorObj = { ...state.sensorObjAll[sensorID] };
      let serialMap = { ...(sensorObj.serialMap || {}) };
      delete serialMap[dtkAdd];
      delete serialMap[serial];
      const repliedNearFieldSetting = newSensorObj.nearFieldSetting || {};
      sensorObj = { ...sensorObj, serialMap };
      let nearFieldSetting = { ...(sensorObj.nearFieldSetting || {}) };
      for (let i = 1; i < 13; i++) {
        let setting = sensorObj[`setting${i}`] || {};
        delete setting[serial];
        const lightNearFieldRemoved = !repliedNearFieldSetting[`setting${i}`]?.includes(lightWifiApMacAddress);
        if (lightNearFieldRemoved) {
          nearFieldSetting[`setting${i}`] = nearFieldSetting[`setting${i}`]?.filter((s) => s !== lightWifiApMacAddress);
        }
        sensorObj = { ...sensorObj, [`setting${i}`]: setting };
      }
      sensorObj = { ...sensorObj, nearFieldSetting };
      state.sensorObjAll[sensorID] = sensorObj;
      return { ...state };
    }
    case "SENSOR_DISCONNECT_SENSOR": {
      const { newMainSensorObj, newControlledSensorObj } = action.payload;
      const mainSensorID = newMainSensorObj.sensorID;
      const controlledSensorID = newControlledSensorObj.sensorID;
      const controlledSensorDtkAdd = newControlledSensorObj.dtkAdd;
      const controlledSensorMacAddress = newControlledSensorObj.wifiApMacAddress;
      let sensorArray = state.sensorObjAll[controlledSensorID]?.sensorArray || [];
      sensorArray = sensorArray.filter((s) => s !== mainSensorID);
      state.sensorObjAll[controlledSensorID].sensorArray = sensorArray;
      let mainSensorObj = state.sensorObjAll[mainSensorID];
      let mainSensorMap = { ...(mainSensorObj.sensorMap || {}) };
      delete mainSensorMap[controlledSensorDtkAdd];
      let sensorMap = { ...(mainSensorObj.sensorMap || {}) };
      delete sensorMap[controlledSensorDtkAdd];
      mainSensorObj = { ...mainSensorObj, sensorMap };
      const repliedNearFieldSetting = newMainSensorObj.nearFieldSetting || {};
      let nearFieldSetting = { ...(mainSensorObj.nearFieldSetting || {}) };
      for (let i = 1; i < 13; i++) {
        let setting = mainSensorObj[`setting${i}`] || {};
        delete setting[controlledSensorID];
        const controlledSensorNearFieldRemoved = !repliedNearFieldSetting[`setting${i}`]?.includes(controlledSensorMacAddress);
        if (controlledSensorNearFieldRemoved) {
          nearFieldSetting[`setting${i}`] = nearFieldSetting[`setting${i}`]?.filter((s) => s !== controlledSensorMacAddress);
        }
        mainSensorObj = { ...mainSensorObj, [`setting${i}`]: setting };
      }
      mainSensorObj = { ...mainSensorObj, nearFieldSetting };
      state.sensorObjAll[mainSensorID] = mainSensorObj;
      return { ...state };
    }
    case "SENSOR_DISCONNECT_DALICTL": {
      const { newSensorObj, newDaliCtlObj } = action.payload;
      const sensorID = newSensorObj.sensorID;
      const daliCtlID = newDaliCtlObj.daliCtlID;
      const daliCtlDtkAdd = newDaliCtlObj.dtkAdd;
      const daliCtlMacAddress = newDaliCtlObj.wifiApMacAddress;
      let sensorArray = state.daliCtlObjAll[daliCtlID]?.sensorArray || [];
      sensorArray = sensorArray.filter((s) => s !== sensorID);
      if (state.daliCtlObjAll[daliCtlID]) {
        state.daliCtlObjAll[daliCtlID].sensorArray = sensorArray;
      }
      let sensorObj = { ...state.sensorObjAll[sensorID] };
      let daliCtlMap = { ...sensorObj.daliCtlMap || {} };
      delete daliCtlMap[daliCtlDtkAdd];
      sensorObj = { ...sensorObj, daliCtlMap };
      const repliedNearFieldSetting = newSensorObj.nearFieldSetting || {};
      let nearFieldSetting = { ...(sensorObj.nearFieldSetting || {}) };
      for (let i = 1; i < 13; i++) {
        let setting = sensorObj[`setting${i}`] || {};
        delete setting[daliCtlID];
        const daliCtlNearFieldRemoved = !repliedNearFieldSetting[`setting${i}`]?.includes(daliCtlMacAddress);
        if (daliCtlNearFieldRemoved) {
          nearFieldSetting[`setting${i}`] = nearFieldSetting[`setting${i}`]?.filter((s) => s !== daliCtlMacAddress);
        }
        sensorObj = { ...sensorObj, [`setting${i}`]: setting };
      }
      sensorObj = { ...sensorObj, nearFieldSetting };
      state.sensorObjAll[sensorID] = sensorObj;
      return { ...state };
    }
    case "SENSOR_DISCONNECT_ALL_LIGHTS": {
      const { sensorID, newSensorObj, serialArray } = action.payload;
      state.sensorObjAll[sensorID] = newSensorObj;
      (serialArray || []).forEach((s) => {
        let arr = state.lightObjAll[s]?.sensorArray || [];
        arr = arr.filter((sen) => sen !== sensorID);
        if (state.lightObjAll[s]) state.lightObjAll[s].sensorArray = arr;
      });
      return { ...state };
    }
    case "SHIFT_SELECTED_DEVICE": {
      const { deviceID, deviceType, deviceObj } = action.payload;
      let shiftSelectedArray = [...state.shiftSelectedArray];
      let obj = { deviceID, deviceType, deviceObj };
      if (!shiftSelectedArray.find((o) => o.deviceID === deviceID)) {
        shiftSelectedArray = [...shiftSelectedArray, obj];
      }
      return {
        ...state,
        shiftSelectedArray,
        selectedID: "",
        selectedDeviceType: "",
        selectedDeviceX: 0,
        selectedDeviceY: 0,
        selectedDeviceObj: {},
      };
    }
    case "SHIFT_SELECTED_MULTI_DEVICES": {
      const objArray = action.payload;
      let shiftSelectedArray = [...state.shiftSelectedArray];
      objArray.forEach((obj) => {
        const item = { deviceID: obj.deviceID, deviceType: obj.deviceType, deviceObj: obj };
        shiftSelectedArray.push(item);
      });
      return { ...state, shiftSelectedArray };
    }
    case "CLEARED_SHIFT_SELECT": {
      return { ...state, shiftSelectedArray: [] };
    }
    case "SHIFT_UNSELECTED_DEVICE": {
      const { deviceID } = action.payload;
      let shiftSelectedArray = [...state.shiftSelectedArray];
      shiftSelectedArray = shiftSelectedArray.filter(
        (obj) => obj.deviceID !== deviceID
      );
      return { ...state, shiftSelectedArray };
    }
    case "DELETE_GAS_SETTINGS": {
      const { groupID, groupDeviceType } = action.payload;
      if (groupDeviceType === "sensor") {
        let newSensorObj = state.sensorObjAll[groupID];
        for (let i = 1; i <= 12; i++) {
          delete newSensorObj[`GAS_setting${i}`];
        }
        state.sensorObjAll[groupID] = newSensorObj;
      }
      if (groupDeviceType === "zoneControl") {
        const zoneControlID = "zc_" + groupID;
        let newZcObj = state.zoneControlObjAll[zoneControlID];
        for (let i = 1; i <= 12; i++) {
          delete newZcObj[`GAS_setting${i}`];
        }
        state.zoneControlObjAll[zoneControlID] = newZcObj;
      }
      return { ...state };
    }
    case "UNCONFIRM_SENSOR_GAS_SETTING": {
      const { sensorObj, settingNumArray } = action.payload;
      const sensorID = sensorObj.sensorID;
      if (sensorObj.enableGroupAction) {
        settingNumArray.forEach((settingNum) => {
          let gasSetting = sensorObj[`GAS_setting${settingNum}`];
          if (gasSetting) {
            Object.keys(gasSetting || {}).forEach((s) => {
              let setting = gasSetting[s] || {};
              setting.confirmed = false;
              gasSetting[s] = setting;
            });
            sensorObj[`GAS_setting${settingNum}`] = gasSetting;
          }
        });
        state.sensorObjAll[sensorID] = sensorObj;
      }
      return { ...state };
    }
    case "UNCONFIRM_ZONE_CONTROL_GAS_SETTING": {
      const { zoneControlObj, settingNumArray } = action.payload;
      const zoneControlID = zoneControlObj.zoneControlID;
      if (zoneControlObj.enableGroupAction) {
        settingNumArray.forEach((settingNum) => {
          let gasSetting = zoneControlObj[`GAS_setting${settingNum}`];
          if (gasSetting) {
            Object.keys(gasSetting || {}).forEach((s) => {
              let setting = gasSetting[s] || {};
              setting.confirmed = false;
              gasSetting[s] = setting;
            });
            zoneControlObj[`GAS_setting${settingNum}`] = gasSetting;
          }
        });
        state.zoneControlObjAll[zoneControlID] = zoneControlObj;

      }
      return { ...state };
    }
    case "SET_CHANNEL_ARRAY": {
      const { meshChannelArray, dtkChannelArray } = action.payload;
      return { ...state, meshChannelArray, dtkChannelArray };
    }
    case "UNSET_DETECTOR_OBJ": {
      const { gatewayID } = action.payload;
      delete state.gatewayObjAll[gatewayID];
      return { ...state, detectorObj: {} };
    }
    case "MAP_ITEM_HIDE_FILTER_TOGGLE": {
      const { filter } = action.payload;
      let mapItemHideFilter = [...state.mapItemHideFilter];
      if (mapItemHideFilter.includes(filter)) {
        mapItemHideFilter = mapItemHideFilter.filter((f) => f !== filter);
      } else {
        mapItemHideFilter = [...mapItemHideFilter, filter];
      }
      return { ...state, mapItemHideFilter };
    }
    case "SET_DETECTED_DEVICE_OBJ_ARRAY": {
      const { deviceObjArray, dtkAddArray } = action.payload;
      return { ...state, detectedDeviceDtkAddArray: dtkAddArray, detectedDeviceObjArray: deviceObjArray, copiedDeviceObj: {}, mapRightClickPos: null }
    }
    case "ADD_RUNNING_JOB": {
      const job = action.payload;
      //check existing job of same listenTopic
      const existingJob = state.runningJobs.find(j => j.listenTopic === job.listenTopic);
      if (existingJob) {
        state.runningJobs = state.runningJobs.filter(j => j.listenTopic !== job.listenTopic);
      }
      state.runningJobs = [...state.runningJobs, job];
      return { ...state };
    }
    case "REMOVE_RUNNING_JOB": {
      const jobID = action.payload;
      state.runningJobs = state.runningJobs.filter(job => job.jobID !== jobID);
      return { ...state };
    }
    case "UPDATE_RUNNING_JOB": {
      const { jobID, updateObj } = action.payload;
      state.runningJobs = state.runningJobs.map(job => job.jobID === jobID ? { ...job, ...updateObj } : job);
      return { ...state };
    }
    case "SET_GENERAL_STATE": {
      const { key, value } = action.payload;
      return { ...state, [key]: value };
    }
    case "SET_GENERAL_MANY_STATE": {
      const obj = action.payload;
      return { ...state, ...obj };
    }
    case "ALL_UNSELECTED": {
      const exceptFieldArray = action.payload?.exceptFieldArray || [];
      let defaultState = {
        activeSerial: "",
        activeGatewayID: "",
        activeReportID: "",
        activeSensorID: "",
        activeZoneControlID: "",
        selectedID: "",
        selectedDeviceType: "",
        selectedDeviceX: 0,
        selectedDeviceY: 0,
        selectedDeviceObj: {},
        selectedGatewayID: "",
        selectedSensorID: "",
        mapLayer: {
          normal: true,
          gatewaySelect: false,
          sensorSelect: false,
          lockLevel: false,
          light: false,
          sensor: false,
          gateway: false,
          luxProfile: false,
          serialNo: false,
          deviceName: false,
          zigbeeAdd: false,
          rssi255Web: false,
          espWeb: false,
          zoneView: state.mapLayer.zoneView,
          deviceHistory: false,
        },
        shiftSelectedArray: [],
        espWebMapMode: "route",
        espWebGatewayID: "",
        espWebDeviceID: "",
        espCheckUnicastSender: {},
        espCheckUnicastReceiver: {},
        espWebPathTargetDevice: {},
        espWebPathArray: [],
        mapRightClickPos: null,
        addDeviceType: null,
        customDisplayFieldName: "",
        detectedDeviceDtkAddArray: [],
        detectedDeviceObjArray: [],
        detectedDevicePosByDtk: {},
        transferTargetDeviceObj: null,
        zonePlanningSelectedZoneControlID: "",
        isDrawingZonepolygon: false,
        connectModbusSlaveID: "",
        currentWorkProgressZoneControlID: "",
        copiedDeviceObj: {},
      }
      exceptFieldArray.forEach(field => {
        delete defaultState[field]
      });
      return { ...state, ...defaultState };
    }
    case "RESET_REDUCER": {
      const email = state.userObj.email;
      return { ...initialState, storedEmail: email };
    }
    case "SET_CURSOR_POS": {
      const { x, y } = action.payload;
      return { ...state, cursorPos: { x, y } };
    }
    case "SET_ON_DRAGGING_DEVICE": {
      const { deviceID, deviceType, x, y } = action.payload;
      return { ...state, onDraggingDevice: { deviceID, deviceType, x, y } };
    }
    case "SET_IS_DRAGGING_DEVICE": {
      const { isDraggingDevice } = action.payload;
      return { ...state, isDraggingDevice: isDraggingDevice };
    }
    case "ZONE_PLANNING_POLYGON_SELECTED": {
      const { zoneControlID } = action.payload;
      return { ...state, zonePlanningSelectedZoneControlID: zoneControlID };
    }
    case "SET_DEVICE_HISTORY_TIME": {
      const { historyTime } = action.payload;
      return { ...state, deviceHistoryTime: historyTime };
    }
    case "SET_DEVICE_HISTORY_DATA": {
      const { deviceHistoryData } = action.payload;
      return { ...state, deviceHistoryData: deviceHistoryData };
    }
    ///////BAT TEST//////////////BAT TEST//////////////BAT TEST///////
    case "SET_VIEWING_BAT_TEST": {
      const { reportID, logData } = action.payload;
      return { ...state, viewingReportID: reportID, batTestDataArray: logData };
    }
    case "BAT_TEST_STATUS_UPDATE": {
      const { serial, reportID, logDataObj, serialUpdate, commandCode, uploadRemark } = action.payload;
      let lightObj = state.lightObjAll[serial];
      lightObj = { ...lightObj, ...serialUpdate };
      state.lightObjAll[serial] = lightObj;
      let batArr = state.batTestDataArray || [];
      const progressArr = batArr.map(obj => obj.progress);
      if (state.viewingReportID === reportID) {
        if (!progressArr.includes(logDataObj.progress)) batArr.push(logDataObj);
      }
      state.batTestDataArray = batArr;
      return { ...state }
    }
    //toolbox
    case "RESPONSE_SERVER_MONITOR_DATA": {
      const { response } = action.payload;
      return { ...state, response_serverMonitorData: { ...state.response_serverMonitorData, ...response } };
    }
    case "UPDATED_LMC_PROPERTY": {
      const { lmcID, updateObj } = action.payload;
      state.lmcObjAll[lmcID] = { ...state.lmcObjAll[lmcID], ...updateObj };
      return { ...state };
    }
    default:
      return state;
  }
};

export const initialState = {
  //screen
  snackbarMsg: {
    title: "",
    severity: "info",
    status: false,
  },
  multiSnackbarMsg: [],
  multiSnackbarMinimized: false,
  showBigProgress: false,
  windowConfirm: false,
  windowConfirmTitle: "",
  showWindowConfirmAlertSign: false,
  onConfirm: () => { },
  onCancel: () => { },
  callback: () => { },
  windowButtonsOnChoose: () => { },
  windowButtonsOnCancel: () => { },
  windowButtons: false,
  windowButtonsTitle: "",
  windowBtnContentArray: [],
  windowAlert: false,
  windowAlertTitle: "",
  windowAlertOnClose: () => { },
  windowPrompt: false,
  windowPromptDefaultValue: "",
  windowPromptTitle: "",
  mapDeviceMessage: {},
  mapDeviceMessageArray: [],
  mapListScrollPosition: 0,
  //user
  storedEmail: "",

  userObj: {},
  serverObj: {},
  serverID: "",
  enableFS: false,
  fs: null,
  serverSocketGateway: [],
  serverSocketWebUser: [],
  tempUserEmail: "",
  //obj and ID
  mapObjAll: {},
  lightObjAll: {},
  gatewayObjAll: {},
  sensorObjAll: {},
  daliCtlObjAll: {},
  zoneControlObjAll: {},
  timeTableObjAll: {},
  timeTableArrAll: [],
  lmcObjAll: {},
  deviceStatus: {},
  windowPromptTitle: "",
  activeMapID: "",
  activeSerial: "",
  activeSensorID: "",
  activeGatewayID: "",
  activeZoneControlID: "",
  activeDaliCtlID: "",
  activeLmcID: "",
  activeReportID: "",
  activeReportObj: {},
  viewingReportID: "",
  batTestDataArray: [],

  // latestDeviceFirmwareVerObj: {},

  //Map use
  uploadedImgUrl: "",
  mapScale: { x: 1, y: 1 },
  mapSize: { x: 1000, y: 600 },
  mapRightClickPos: null,
  layerScale: 1,
  layerPos: { x: 0, y: 0 },
  mapMode: "normal",
  mapRightMode: "normal",
  mapLayer: {
    normal: true,
    gatewaySelect: false,
    sensorSelect: false,
    lockLevel: false,
    light: false,
    sensor: false,
    gateway: false,
    daliCtl: false,
    zoneControl: false,
    luxProfile: false,
    serialNo: false,
    deviceName: false,
    zigbeeAdd: false,
    rssi255Web: false,
    batTest: false,
    channel: false,
    realDimension: false,
    customFieldDisplay: false,
    workProgress: false,
    deviceVersion: false,
    neigbourMapSign: false,
    zoneView: false,
    groupActionStatus: false,
    connectedBy: false,
    deviceTags: false,
  },
  viewLineType: { gateway: true, sensor: true, timer: true, vituralButton: true, light: true, daliCtl: true, esp: false, lmc: true, slaveLight: true, slaveSensor: true },
  enablePan: true,
  enableZoom: "",
  selectedID: "",
  selectedDeviceType: "",
  selectedDeviceObj: {},
  selectedDeviceX: 0,
  selectedDeviceY: 0,
  selectMultiArray: [],
  shiftSelectedArray: [],
  espWebMapMode: "route", //"web":route table line, "check":unicast check, "setPath":set manual path,
  espWebGatewayID: "",
  espWebDeviceID: "",
  espCheckUnicastSender: {},
  espCheckUnicastReceiver: {},
  espWebPathTargetDevice: {},
  espWebPathArray: [],
  meshChannelArray: [],
  dtkChannelArray: [],
  addDeviceType: null,
  mapInfantryMode: false,
  mapItemHideFilter: [],
  detectorObj: {},
  detectorFunction: "basicDetect",
  realDimensionObj: {},
  customDisplayFieldName: "",
  filterDetectorConnectedDevices: true,
  detectedDeviceDtkAddArray: [],
  detectedDeviceObjArray: [],
  detectedDevicePosByDtk: {},
  transferTargetDeviceObj: null,
  openGatewayAdvanceHistoryMordal: false,
  connectModbusSlaveID: "",
  copiedDeviceObj: {},
  deviceNameHidden: {},
  devicePropertyHidden: {},
  createSlaveLightMode: false,
  detectedFilter: {
    hideDeviceInOtherMap: false,
    hideDeviceInMap: false,
    hideLight: false,
    hideSensor: false,
    hideDaliCtl: false,
    hideLatestFirmware: false,
    hideDeviceNotInMap: false
  },
  detectedFilterHideOtherMapExcludeTextArray: ["WO"],
  detectorLatestVersionList: null,
  openDetectorBroadcastModal: false,
  allMapDeviceObj: null,
  backgroundBroadcastDeviceUpdateSouce: null,
  runningJobs: [],
  jobProgressArray: [],
  gasObjAll: null,
  selectedGasID: "",
  progressQueue: [],
  deviceHistoryTime: null,
  deviceHistoryData: {},
  tagHideObj: {},
  assigningTagID: "",
};

const addMapDeviceMessage = (state, deviceIDArr, messageArr) => {
  deviceIDArr.forEach((deviceID, key) => {
    const obj = { deviceID, message: messageArr[key], timeStamp: moment().valueOf() };
    state.mapDeviceMessage[deviceID] = messageArr[key];
    state.mapDeviceMessageArray.unshift(obj);
    if (state.mapDeviceMessageArray.length > 100) state.mapDeviceMessageArray.pop();
  });
  return state;
}
